export default "__VITE_ASSET__q_lkx4A___"